// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {}

export const mutations = {}

export const actions = {
  fetchReports101(_, payload) {
    return ApiService.fetchReports101(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReports102(_, payload) {
    return ApiService.fetchReports102(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReports103(_, payload) {
    return ApiService.fetchReports103(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReports104(_, payload) {
    return ApiService.fetchReports104(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReports105(_, payload) {
    return ApiService.fetchReports105(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReports106(_, payload) {
    return ApiService.fetchReports106(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchReports107(_, payload) {
    return ApiService.fetchReports107(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  workTimeReprocess(_, payload) {
    return ApiService.workTimeReprocess(payload).catch((error) => {
      throw error
    })
  },
}
